var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-anaglyph-select",attrs:{"data-testid":"anaglyph_select"}},[_c('v-select',{staticStyle:{"max-width":"500px"},attrs:{"label":_vm.$t('common.anaglyph_glasses'),"items":_vm.options,"disabled":_vm.disabled},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }